import { styled, OutlinedInput, WithTheme } from '@material-ui/core'
import { Icon as IconBase } from '@iconify/react'

const SEARCH_WIDTH = 310

interface IconProps extends WithTheme {
  clickable?: boolean
}

export const Input = styled(OutlinedInput)(({ theme }) => ({
  width: SEARCH_WIDTH,
  fontSize: 14,
  lineHeight: '14px',
  '& fieldset': {
    top: 0,
  },
}))

export const Icon = styled(IconBase)(({ theme, clickable }: IconProps) => ({
  fontSize: 22,
  cursor: clickable ? 'pointer' : 'default',
  color: theme.palette.primary.main,
}))
